// ── useKalshiAccount — Auto-connect lifecycle hook (MT relay) ────
// On mount, checks the relay for stored credentials and connects if found.

import { useEffect } from 'react';
import { useAccountStore } from '../stores/accountStore';
import { useAuthStore } from '../stores/authStore';

export function useKalshiAccount(): void {
  const authStatus = useAuthStore((s) => s.status);
  const userId = useAuthStore((s) => s.user?.id);
  const orgId = useAuthStore((s) => s.user?.orgId);

  useEffect(() => {
    if (authStatus !== 'authenticated') return;

    useAccountStore.getState().checkCredentials();

    return () => {
      useAccountStore.getState().disconnect();
    };
    // Cross-tab auth can replace an already-authenticated identity. Clean up
    // the old account generation before checking the new holdings scope.
  }, [authStatus, userId, orgId]);
}
